<template>
	<div
		class="p2 bg4 b1 bc7 r2 fs3"
		:class="[{ cu2: hasChildren }, { cu1: !hasChildren }]"
		@click.stop="isExpanded = !isExpanded"
	>
		<div class="lh125 c1 fw7">
			{{ node.name }}
			<j-tag v-if="node.isOptional" :label="$t('optional')" size="xsmall" />
		</div>
		<div class="lh125" :class="{ cError: node.isValid === false }">
			{{ $t("remaining_amount") }}:
			{{ node.formattedValue ? node.formattedValue : "N/A" }}
		</div>
		<div v-if="hasChildren && !isExpanded" class="c2 fs3 fw7 lh125 mt1">
			{{ $t("see_sub_benefits") }}
		</div>
		<div v-if="hasChildren && isExpanded" class="c2 fs3 fw7 lh125 mt1">
			{{ $t("hide_sub_benefits") }}
		</div>
		<template v-if="hasChildren && isExpanded">
			<claim-balance-node
				v-for="(item, i) in node.children"
				:key="i"
				:node="item"
				class="mt2"
			/>
		</template>
	</div>
</template>

<script>
import JTag from "@/components/JTag"
export default {
	components: { JTag },
	name: "ClaimBalanceNode",
	props: { node: { type: Object } },
	data() {
		return {
			isExpanded: false
		}
	},
	computed: {
		hasChildren() {
			return this.node.children && this.node.children.length
		}
	}
}
</script>